const PageBase = () => import('@/modules/stats/base/PageBase')
const PageBasemdchangelog = () => import('@/modules/stats/base/PageBasemdchangelog')
const PageBasemdtable = () => import('@/modules/stats/base/PageBasemdtable')
const PageResource = () => import('@/modules/stats/resource/PageResource')
const PageCharts = () => import('@/modules/stats/charts/PageCharts')
const addCharts = () => import('@/modules/stats/charts/operators/AddChartsOperators')
export default [
  {
    path: '/stats/base',
    name: 'stats_base',
    component: PageBase,
    meta: {
      title: '元数据',
    },
  },
  {
    path: '/stats/basemdchangelog',
    name: 'stats_mdchangelog',
    component: PageBasemdchangelog,
    meta: {
      title: '表结构更改记录',
    },
  },

  {
    path: '/stats/basemdtable',
    name: 'stats_mdtable',
    component: PageBasemdtable,
    meta: {
      title: '表结构数据定义',
    },
  },

  {
    path: '/stats/resource',
    name: 'stats_resource',
    component: PageResource,
    meta: {
      title: '数据包',
    },
  },

  {
    path: '/stats/addCharts',
    name: 'stats_addCharts',
    component: addCharts,
    meta: {
      title: '新建图表',
    },
  },
  {
    path: '/stats/setCharts',
    name: 'stats_setCharts',
    component: PageCharts,
    meta: {
      title: '设置图表',
    },
  },

]
